export const CONFIG = {
    API_HOST: "https://0lqty92n3a.execute-api.ap-southeast-1.amazonaws.com/test",
    NETWORK_TIMEOUT: 30000,
} 
